module.exports = __webpack_public_path__ + "static/media/generic@3x.e1143bd1.png";